export const DX_IOS_APP_LINK = 'https://apps.apple.com/us/app/dreamx/id6444721724';
export const DX_ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.sporta.dreampayapp&referrer=utm_source%3Ddxwebsite';
